import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

export const getRespondentData = (data, message) => {
  const respondent = get(data, 'respondent', null);
  if (!respondent) return null;
  const teamOriginalRespondent = get(data, 'originalRespondent', null);
  const isTeamUser = !isEmpty(teamOriginalRespondent);
  const respondentToShow = isTeamUser ? teamOriginalRespondent : respondent;

  const {
    displayableName,
    name,
    avatar: { thumbMiddle: respondentAvatar } = {},
    role,
  } = respondentToShow;
  const respondentName = name || displayableName;
  const teamName = isTeamUser ? get(respondent, 'displayableName') : '';
  const teamOrganization = isTeamUser
    ? get(respondent, 'organizationName')
    : '';

  if (message) {
    return `${respondentName}${role ? `, ${role}` : ''} ${
      teamName ? `(${teamName})` : ''
    }`;
  }

  return {
    respondentName,
    respondentAvatar,
    role,
    teamName,
    teamOrganization,
  };
};



// WEBPACK FOOTER //
// ./src/components/Survey/helpers/getRespondentData.js